<mat-card class="top-card mat-elevation-z0 no-padding overflowHidden">
  <div
    class="upper-space"
    [ngClass]="inputProduct.type == null ? 'under-space' : ''"
  >
    <client-product-creator
      [inputProduct]="inputProduct"
      [inputProject]="inputProject"
      [oldSystemImmo]="oldSystemImmo"
      (productInitialized)="productInitialized.emit($event)"
    ></client-product-creator>

    <div
      *ngIf="inputProduct.type === PRODUCT_TYPES.IP_BOARD.value"
      class="product-form-margin"
    >
      <client-ip-board-form
        [ipBoard]="inputProduct"
        [project]="inputProject"
        [oldSystemImmo]="oldSystemImmo"
        (save)="save.emit()"
      ></client-ip-board-form>
    </div>

    <div
      *ngIf="inputProduct.type === CLIENT_WINDOW_STICKER_TYPE"
      class="product-form-margin"
    >
      <client-window-sticker-form
        [windowSticker]="inputProduct"
      ></client-window-sticker-form>
    </div>

    <div
      *ngIf="inputProduct.type === PRODUCT_TYPES.BOARD.value"
      class="product-form-margin"
    >
      <board-form
        [inputProject]="inputProject"
        [inputProduct]="inputProduct"
        [client]="true"
      ></board-form>
    </div>

    <div
      *ngIf="inputProduct.type === PRODUCT_TYPES.OTHER_PRODUCT.value"
      class="product-form-margin"
    >
      <other-product-form
        [inputProject]="inputProject"
        [inputProduct]="inputProduct"
        [client]="true"
      ></other-product-form>
    </div>
  </div>
</mat-card>
